import client from '@/apis/aniftyBackend/client';
import { PostHeaderImageResponse } from '@/apis/aniftyBackend/users/interface';

const setHeaderImage = async (
  userID: string,
  headerImageFile: File
): Promise<PostHeaderImageResponse> => {
  // construct request as multipart/form-data
  const data = new FormData();
  data.append('file', headerImageFile);

  const response = await client.post<PostHeaderImageResponse>(
    `/api/users/${userID}/header_image`,
    data
  );

  return response.data;
};

export default setHeaderImage;
